export default __webpack_public_path__ + "static/media/pic1.b3b24b6d.jpg";